export function getView(headers) {
  return (
    headers !== undefined && headers !== null && Object.keys(headers).length
  )
}
